window.DtGiftPackagingRules = (() => {
  const limits = { 1: { canister: 1, small: 0, large: 0 }, 2: { canister: 2, small: 1, large: 0 }, 4: { canister: 4, small: 2, large: 1 }, 8: { canister: 8, small: 4, large: 2 }, 12: { canister: 12, small: 6, large: 3 } };
  const terryLimits = { 1: { canister: 1, small: 0, large: 0 }, 2: { canister: 2, small: 2, large: 1 }, 4: { canister: 4, small: 4, large: 2 }, 8: { canister: 8, small: 8, large: 4 }, 12: { canister: 12, small: 12, large: 6 } };
  const packSizes = { 'banana-super-light-terry-bath-towels-400-gsm-75-x-150-cm': 4 };
  const variants = { '67678890033365': 'small', '67600278487253': 'large', '67600278520021': 'canister', '67600339501269': 'canister', '67601463181525': 'canister', '67601464393941': 'canister', '67601465213141': 'canister' };
  const product = (url) => {
    const handle = String(url || '').split('?')[0].split('/').pop();
    if (/face|hair|hand|canister|gifting/.test(handle)) return null;
    const isCloth = /^(?:banana-double-cloth|aluvera-double-cloth|alu-vera-double-cloth|aloevera-double-cloth|banana-jacquard-floral|buy-banana-jacquard-floral)/.test(handle) && handle.includes('bath-towel');
    const isTerry = handle.startsWith('alufern-terry-bath-towel') || handle.startsWith('banana-terry-bath-towels-400-gsm') || handle.startsWith('banana-terry-bath-towels-plus-size') || handle === 'banana-terry-bath-towel-dual-zones-550-gsm-75-x-150-cm' || (handle.startsWith('banana-super-light') && /70-x-140|75-x-150|75-x-180/.test(handle));
    if (!isCloth && !isTerry) return null;
    const packSize = packSizes[handle] || Number(handle.match(/pack-of-(\d+)/)?.[1]) || 1;
    const familyLimits = isTerry ? terryLimits : limits;
    return familyLimits[packSize] ? { packSize, limits: familyLimits[packSize], weights: { canister: 1, small: isTerry ? 1 : Math.min(2, packSize), large: isTerry ? 2 : 4 } } : null;
  };
  const cartState = (items, overrideKey, overrideQuantity) => {
    const sources = new Map();
    items.forEach(item => {
      if (item.handle === 'gift-packaging-add-on') return;
      const rule = product(item.handle);
      if (!rule) return;
      const id = String(item.variant_id || item.id);
      const source = sources.get(id) || { rule, quantity: 0, used: 0, selected: { canister: 0, small: 0, large: 0 } };
      source.quantity += Number(item.quantity) || 0;
      sources.set(id, source);
    });
    const updates = {};
    items.forEach(item => {
      if (item.handle !== 'gift-packaging-add-on') return;
      const requested = item.key === overrideKey ? overrideQuantity : Number(item.quantity) || 0;
      const source = sources.get(String(item.properties?._gift_for_variant));
      const type = variants[String(item.variant_id || item.id)];
      let count;
      if (source && type) {
        const weight = source.rule.weights[type];
        const remaining = Math.floor(Math.max(0, source.rule.packSize * source.quantity - source.used) / weight);
        count = Math.min(requested, remaining, Math.max(0, source.rule.limits[type] * source.quantity - source.selected[type]));
        source.selected[type] += count;
        source.used += count * weight;
      } else {
        count = 0;
      }
      if (count !== requested) updates[item.key] = count;
    });
    return { updates };
  };
  return { product, cartState };
})();

(function () {
  if (window.__dtFreebieCartGuardLoaded) return;
  window.__dtFreebieCartGuardLoaded = true;

  var GIFT_VARIANTS = [54874685571285, 54874703790293, 54874707165397, 68015950463189, 68017340448981];
  var DIWALI_GIFT_ID = 68017340448981;
  var giftingProductIds = [];
  var giftingProductsPromise = null;
  var reconcilePromise = null;
  var nativeCheckoutPending = false;
  var nativeCheckoutApproved = false;

  function isGift(line) {
    var properties = line && line.properties || {};
    return GIFT_VARIANTS.includes(Number(line && (line.variant_id || line.id))) ||
      properties._dt_diwali_gift === '1' || Boolean(properties._dt_retention_gift);
  }

  function isDiwaliGift(line) {
    return Number(line && (line.variant_id || line.id)) === DIWALI_GIFT_ID && (line.properties || {})._dt_diwali_gift === '1';
  }

  // Keys of Freebies (retention) gift lines the cart still qualifies for, using the same
  // per-bundle tier rule as dt-retention-core.js so the two scripts never fight over a line.
  function retentionGiftKeys(cart) {
    var keys = new Set();
    var sync = window.DTRetentionGiftSync;
    var config = sync && sync.parseConfig ? sync.parseConfig() : null;
    if (!config || !cart || (cart.attributes || {})[sync.campaignAttribute] !== sync.campaignValue) return keys;
    var bundles = new Map();
    cart.items.forEach(function (line) {
      var properties = line.properties || {};
      var bundleId = String(properties._dt_retention_bundle || '').trim();
      if (!bundleId) return;
      var bundle = bundles.get(bundleId) || { subtotal: 0, gifts: [] };
      if (String(properties._dt_retention_gift || '').trim()) {
        bundle.gifts.push(line);
      } else if (config.eligibleProductIds.has(String(line.product_id))) {
        bundle.subtotal += Number(line.final_line_price || 0);
      }
      bundles.set(bundleId, bundle);
    });
    bundles.forEach(function (bundle) {
      var tier = sync.unlockedTier(bundle.subtotal, config);
      var gift = tier && bundle.gifts.find(function (line) { return Number(line.variant_id) === tier.variantId; });
      if (gift && gift.key) keys.add(gift.key);
    });
    return keys;
  }

  function hasGiftingProduct(cart) {
    return cart.items.some(function (line) {
      return !isGift(line) && Number(line.quantity) > 0 && giftingProductIds.includes(Number(line.product_id));
    });
  }

  function showGiftState(cart) {
    var eligible = hasGiftingProduct(cart);
    var gift = cart.items.find(isDiwaliGift);
    var redeemed = eligible && gift && Number(gift.final_line_price) === 0;
    var hasOtherProducts = cart.items.some(function (line) { return !isGift(line) && Number(line.quantity) > 0; });
    document.querySelectorAll('.dt-diwali-gift-row').forEach(function (row) {
      if (!hasOtherProducts) { row.remove(); return; }
      row.classList.toggle('is-preview', !redeemed);
      var status = row.querySelector('.dt-diwali-gift-row__status');
      if (status) status.textContent = !eligible ? row.dataset.giftingPrompt : redeemed ? 'Redeemed' : 'Offer discount pending';
      var link = row.querySelector('.dt-diwali-gift-row__link');
      if (link) link.hidden = eligible;
    });
  }

  function readGiftingProductIds() {
    if (!giftingProductsPromise) {
      var root = window.Shopify?.routes?.root || '/';
      giftingProductsPromise = fetch(root + 'collections/gifting?view=dt-gifting-eligibility&page=1', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to read gifting offer eligibility.');
          return response.json();
        })
        .then(function (ids) {
          if (!Array.isArray(ids)) throw new Error('Invalid gifting offer eligibility.');
          giftingProductIds = ids;
        })
        .catch(function (error) {
          giftingProductsPromise = null;
          throw error;
        });
    }
    return giftingProductsPromise;
  }

  async function readCart() {
    var response = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Unable to read cart.');
    return response.json();
  }

  async function reconcile(cart) {
    while (reconcilePromise) {
      await reconcilePromise;
      cart = null;
    }
    reconcilePromise = (async function () {
      if (window.CartController?.pendingRemovalKeys?.size || window.CartController?.pendingRemovalPromise) {
        var removalSynced = await window.CartController.flushPendingRemovals();
        if (!removalSynced) throw new Error('Unable to sync product removal before reconciling gift items.');
        cart = null;
      }
      if (window.CartController?.pendingQuantityUpdates?.size || window.CartController?.pendingQuantityPromise) {
        var synced = await window.CartController.flushQuantityUpdates();
        if (!synced) throw new Error('Unable to sync cart before reconciling gift items.');
        cart = null;
      }
      var cartAndEligibility = await Promise.all([
        cart && Array.isArray(cart.items) && cart.attributes ? cart : readCart(),
        readGiftingProductIds()
      ]);
      var sourceCart = cartAndEligibility[0];
      var keptGift = false;
      var updates = {};
      var qualifiedRetentionGifts = retentionGiftKeys(sourceCart);
      sourceCart.items.forEach(function (line) {
        if (!isGift(line) || !line.key) return;
        if (qualifiedRetentionGifts.has(line.key)) {
          if (Number(line.quantity) !== 1) updates[line.key] = 1;
        } else if (isDiwaliGift(line) && hasGiftingProduct(sourceCart) && !keptGift) {
          keptGift = true;
          if (Number(line.quantity) !== 1) updates[line.key] = 1;
        } else {
          updates[line.key] = 0;
        }
      });
      Object.assign(updates, window.DtGiftPackagingRules.cartState(sourceCart.items).updates);
      var correctedCart = sourceCart;
      if (Object.keys(updates).length) {
        var response = await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        if (!response.ok) throw new Error('Unable to reconcile gift items.');
        correctedCart = await readCart();
      }
      if (hasGiftingProduct(correctedCart) && !correctedCart.items.some(isDiwaliGift)) {
        var addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: DIWALI_GIFT_ID, quantity: 1, properties: { _dt_diwali_gift: '1', Towel: 'Banana Terry Hand Towels, 40 x 60 cm, Pack of 2' } })
        });
        if (!addResponse.ok) throw new Error('Unable to add the complimentary towel.');
        correctedCart = await readCart();
      }
      var keptRetentionGifts = retentionGiftKeys(correctedCart);
      var gifts = correctedCart.items.filter(function (line) {
        return isGift(line) && !(keptRetentionGifts.has(line.key) && Number(line.quantity) === 1);
      });
      if (gifts.some(function (line) { return !isDiwaliGift(line) || Number(line.quantity) !== 1; }) || gifts.length > 1 ||
          Boolean(gifts.length) !== hasGiftingProduct(correctedCart) ||
          Object.keys(window.DtGiftPackagingRules.cartState(correctedCart.items).updates).length) {
        throw new Error('Gift items remained invalid in the cart.');
      }
      showGiftState(correctedCart);
      if (correctedCart === sourceCart) return sourceCart;
      if (window.CartController) {
        await window.CartController.refreshCart();
        window.CartController.updateCartCount();
        await Promise.all([
          window.CartController.refreshCartDrawerHTML({ refreshRecommendations: false }),
          window.CartController.refreshCartPageHTML()
        ]);
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: correctedCart }));
      return correctedCart;
    })();
    try {
      return await reconcilePromise;
    } finally {
      reconcilePromise = null;
    }
  }

  function reconcileSafely(cart) {
    reconcile(cart).catch(function (error) {
      document.querySelectorAll('.dt-diwali-gift-row__status').forEach(function (status) {
        status.textContent = 'We couldn’t add your complimentary towels. Please try again.';
      });
      console.warn('[Cart] Unable to reconcile gift items.', error);
    });
  }

  window.dtReconcileFreebieCart = reconcile;

  function blockStandaloneGiftAdd(event) {
    var form = event.target && event.target.closest ? event.target.closest('form[action*="/cart/add"]') : null;
    if (!form) return;
    var variantInput = form.querySelector('[name="id"]');
    if (!GIFT_VARIANTS.includes(Number(variantInput && variantInput.value))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  document.addEventListener('cart:updated', function (event) {
    reconcileSafely(event.detail);
  }, { passive: true });
  document.addEventListener('dt:cart-intent', function () { reconcileSafely(); }, { passive: true });
  document.addEventListener('cart-drawer:opening', function () { reconcileSafely(); }, { passive: true });
  document.addEventListener('submit', blockStandaloneGiftAdd, true);
  document.addEventListener('click', blockStandaloneGiftAdd, true);

  function scheduleInitialReconciliation() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function () { reconcileSafely(); }, { timeout: 1500 });
    } else {
      window.setTimeout(function () { reconcileSafely(); }, 500);
    }
  }
  scheduleInitialReconciliation();
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) scheduleInitialReconciliation();
  });

  function isGoKwikCheckout(element) {
    return Boolean(element && element.closest && element.closest('.gokwik-checkout, [data-gokwik-checkout], [onclick*="gokwik" i]'));
  }

  function isNativeCheckoutControl(element) {
    if (!element || !element.matches) return false;
    return element.matches('[name="checkout"], #checkout, .cart__checkout-button, .cart-drawer__checkout-btn, a[href^="/checkout"], a[href*="/checkout?"]');
  }

  function continueNativeCheckout(control, form) {
    if (control && 'disabled' in control) control.disabled = false;
    if (form) {
      if (typeof form.requestSubmit === 'function') {
        nativeCheckoutApproved = true;
        form.requestSubmit(control && control.form === form ? control : undefined);
      } else {
        form.submit();
      }
      return;
    }
    window.location.assign(control && control.href ? control.href : '/checkout');
  }

  function guardNativeCheckout(event, control, form) {
    if (nativeCheckoutApproved) {
      nativeCheckoutApproved = false;
      return;
    }
    if (nativeCheckoutPending || isGoKwikCheckout(control || form)) {
      if (nativeCheckoutPending) event.preventDefault();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    nativeCheckoutPending = true;
    if (control && 'disabled' in control) control.disabled = true;
    reconcile()
      .then(function () { continueNativeCheckout(control, form); })
      .catch(function (error) {
        if (control && 'disabled' in control) control.disabled = false;
        console.warn('[Cart] Checkout paused because gift items could not be reconciled.', error);
      })
      .finally(function () { nativeCheckoutPending = false; });
  }

  document.addEventListener('click', function (event) {
    var control = event.target && event.target.closest ? event.target.closest('[name="checkout"], #checkout, .cart__checkout-button, .cart-drawer__checkout-btn, a[href^="/checkout"], a[href*="/checkout?"]') : null;
    if (!isNativeCheckoutControl(control) || isGoKwikCheckout(control)) return;
    guardNativeCheckout(event, control, control.form || control.closest('form'));
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || isGoKwikCheckout(form)) return;
    var submitter = event.submitter;
    var checkoutControl = isNativeCheckoutControl(submitter) ? submitter : form.querySelector('[name="checkout"], #checkout, .cart__checkout-button, .cart-drawer__checkout-btn');
    if (checkoutControl) guardNativeCheckout(event, checkoutControl, form);
  }, true);
})();
